import {aliases,mdi} from 'vuetify/iconsets/mdi'
import {fa} from 'vuetify/iconsets/fa'
import {md} from 'vuetify/iconsets/md'
export const enabled = true
export const isDev = false
export function iconsConfiguration() {

  return {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi,fa,md }
  }
}

